/**
 * ScrollProgress — thin gradient bar at top of viewport.
 * Uses direct DOM manipulation (no React state) for zero-cost scroll tracking.
 */
import { useEffect, useRef } from "react";

export default function ScrollProgress() {
  const barRef = useRef(null);

  useEffect(() => {
    const bar = barRef.current;
    if (!bar) return;

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        bar.style.width = `${pct}%`;
        ticking = false;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-[3px] bg-transparent pointer-events-none" data-testid="scroll-progress">
      <div
        ref={barRef}
        className="h-full bg-gradient-to-r from-brand-aqua to-brand-pink will-change-[width]"
        style={{ width: "0%", transition: "width 80ms linear" }}
      />
    </div>
  );
}
